import { t } from 'i18next';

export function buildHead(pageTitleKey: string) {
  return {
    meta: [
      {
        title: t(`pages.${pageTitleKey}.pageTitle`),
      },
    ],
  };
}
